import '../../Assets/Styles/home.css';
import '../../Assets/Styles/blog.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';
import BlogHighlightCarousel from '../../Components/BlogHighlightCarousel';

// Set assets
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 
import imageFallback from '../../Assets/Images/imagePlaceholder.jpg'; 


import {
	getSlugWithId,
	handleClickScroll
} from '../../Components/Utils';


const Blog = (props) => {
	
// Set var from props
const {
	setDialog,
	setLoginStatus,
} = props;

// set Use of history for PUSH 
var navigate = useNavigate();
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
	
const [selectedCategories, setSelectedCategories] = React.useState(['Todas']);
const [categories, setCategories] = React.useState(['Todas']); // começa com "Todas"
const [categoriesData, setCategoriesData] = React.useState([]);
const [posts, setPosts] = React.useState([]);
const [noticiasDestaque, setNoticiasDestaque] = React.useState([]);

const [page, setPage] = React.useState(1);
const [isLoadingMore, setIsLoadingMore] = React.useState(false);
const [temMaisNoticias, setTemMaisNoticias] = React.useState(true);


// Função para lidar com a seleção no filtro de categorias
const toggleCategory = (category) => {
	if (category === 'Todas') {
	  setSelectedCategories(['Todas']);

		// Scroll to news after 0.7 seconds
		setTimeout(() => {
			handleClickScroll('newsMainSection');
		},700);	

	  return;
	}
  
	let updated;
	if (selectedCategories.includes(category)) {
	  updated = selectedCategories.filter((c) => c !== category);
	} else {
	  updated = [...selectedCategories.filter(c => c !== 'Todas'), category];
	}
  
	const allExceptTodas = categories.filter(c => c !== 'Todas');
  
	// ✅ Se todas as categorias (exceto "Todas") forem selecionadas, volta pra "Todas"
	if (updated.length === allExceptTodas.length) {
	  updated = ['Todas'];
	}
  
	// ✅ Se nenhuma estiver selecionada, marca "Todas" automaticamente
	if (updated.length === 0) {
	  updated = ['Todas'];
	}
  
	setSelectedCategories(updated);

	// Scroll to news after 0.7 seconds
	setTimeout(() => {
		handleClickScroll('newsMainSection');
	},700);	

  };
  
// Função para buscar categorias
React.useEffect(() => {
	fetch('https://estacaodoolho.kindle.com.br/wp-json/wp/v2/categories?hide_empty=true&per_page=100')
		.then(res => res.json())
		.then(data => {
		setCategoriesData(data);
		const nomesDasCategorias = data.map(cat => cat.name);
		setCategories(['Todas', ...nomesDasCategorias]);
		})
		.catch(err => {
		console.error('Erro ao carregar categorias:', err);
		});
}, []);

// Função para buscar posts em destaque
React.useEffect(() => {
	const carregarDestaques = async () => {
	  try {
		const tagRes = await fetch('https://estacaodoolho.kindle.com.br/wp-json/wp/v2/tags?slug=destaque');
		const tagData = await tagRes.json();
		const tagId = tagData[0]?.id;
  
		if (!tagId) return;
  
		const postsRes = await fetch(`https://estacaodoolho.kindle.com.br/wp-json/wp/v2/posts?_embed&per_page=5&tags=${tagId}&orderby=date&order=desc`);
		const postsData = await postsRes.json();
  
		setNoticiasDestaque(postsData);
	  } catch (err) {
		console.error('Erro ao buscar destaques por tag:', err);
	  }
	};
  
	carregarDestaques();
	window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);  

// Função para buscar posts
React.useEffect(() => {
	const buscarPosts = async () => {
	try {
	let url = 'https://estacaodoolho.kindle.com.br/wp-json/wp/v2/posts?_embed&per_page=12&orderby=date&order=desc';

	if (!selectedCategories.includes('Todas')) {
		// Mapeia os nomes para os IDs corretos
		const categoriaIds = categoriesData
		.filter(cat => selectedCategories.includes(cat.name))
		.map(cat => cat.id);

		if (categoriaIds.length > 0) {
		url += `&categories=${categoriaIds.join(',')}`;
		}
	}

	const res = await fetch(url);
	const data = await res.json();

	// rest page
	setPage(1);

	// ⬇️ Verifica se há mais páginas
	const totalPages = res.headers.get('x-wp-totalpages');
	if ((page+1) >= totalPages) {
		setTemMaisNoticias(false); // Oculta botão "Carregar mais"
	} else {
		setTemMaisNoticias(true); // Mostra botão "Carregar mais"
	}

	setPosts(data);


	} catch (err) {
	console.error('Erro ao buscar posts:', err);
	}
	};
	buscarPosts();

}, [selectedCategories]);

// Função para carregar mais postagens
const loadMorePosts = async () => {
	try {
	  setIsLoadingMore(true);
	  let url = `https://estacaodoolho.kindle.com.br/wp-json/wp/v2/posts?_embed&per_page=12&page=${page + 1}&orderby=date&order=desc`;
  
	  if (!selectedCategories.includes('Todas')) {
		const categoriaIds = categoriesData
		  .filter(cat => selectedCategories.includes(cat.name))
		  .map(cat => cat.id);
  
		if (categoriaIds.length > 0) {
		  url += `&categories=${categoriaIds.join(',')}`;
		}
	  }
  
	  const res = await fetch(url);
	  if (!res.ok) throw new Error('Sem mais posts');
	  const data = await res.json();

		// ⬇️ Verifica se há mais páginas
		const totalPages = res.headers.get('x-wp-totalpages');
		if ((page+1) >= totalPages) {
			setTemMaisNoticias(false); // Oculta botão "Carregar mais"
		}

	  setPosts(prev => [...prev, ...data]);
	  setPage(prev => prev + 1);
	} catch (err) {
	  console.warn('Fim da lista ou erro ao carregar mais:', err.message);
	} finally {
	  setIsLoadingMore(false);
	}
  };

// Função para lidar com o clique na postagem
const handleClick = (noticia) => {
	const url = getSlugWithId(noticia.title?.rendered, noticia.id);
    navigate(url);
};

  return (
	<>
	<Helmet>
	  <title>Notícias</title>
	  <meta name="description" content="Notícias sobre oftalmologia." />
	  <meta name="keywords" content="oftalmologia, clínica, saúde ocular, exames de vista" />
	</Helmet>

	<div id="blogMainSection" className="wrapper_blog__content" >

		<HeaderView />

		<div className={isMobile ? "mobileWrapperBox wrapper_blog__content_container" : "wrapper_blog__content_container"}> 
		
			{/*<!-- Filter Box  -->*/}
			<div className="wrapper_blog__content_container_block" style={{marginTop:"1rem"}}>  

				<div className="wrapper_blog__content_container_block_filter">

					<div className="title">Filtrar por categoria</div>
					<div className="selectors">

						{categories.map((category) => (
							<Button
								key={category}
								label={category}
								className={selectedCategories.includes(category) ? 'selectedCategoryButton' : 'unselectedCategoryButton'}
								onClick={() => toggleCategory(category)}
								rounded
							/>
						))}

					</div>

				</div>

			</div>	

			{/*<!-- Carousel Paginator  -->*/}
			{/*<div className="wrapper_blog__content_container_block" style={{marginTop:"0.25rem"}}>  

			</div>*/}				

			{/*<!-- Carousel -->*/}
			<div className="wrapper_blog__content_container_block">  

			 	<BlogHighlightCarousel posts={noticiasDestaque} />

			</div>			
		
			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div id="newsMainSection" className="wrapper_blog__content_container_block">  

				<div className="wrapper_blog__content_container_highlight" style={{marginTop:"1.5rem",alignItems:"flex-start",width:"100%"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_blog__content_container_highlight_title" style={{fontSize:"2.5rem",fontWeight:"600"}}>Últimas postagens</div>

				</div>

				<div className="wrapper_blog__content_container_cards" style={{flexWrap:"wrap",marginTop:"3.5rem"}}>

					{posts.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category" style={{paddingLeft:0}}>

								{categories.map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}					

				</div>		

				<div className="wrapper_blog__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem"}}>

					{temMaisNoticias && (
					<Button
						label={isLoadingMore ? "Carregando..." : "Carregar mais notícias"}
						rounded
						className="pT10 headerButtonRight filled"
						style={{ marginTop: "0.5rem" }}
						onClick={loadMorePosts}
					/>
					)}

				</div>

			</div>	
		

		</div>


	</div>
	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Blog);	


